import React, { forwardRef, useMemo } from 'react';
import classNames from 'classnames';
import { UserStoryShowcaseEntity } from '@/swagger';
import SplitSwiperSection, { SplitSwiperCard } from '@/src/components/feature/SplitSwiperSection';
import ConditionalFragment from '@/components/common/ConditionalFragment';
import { isSet } from '@/utils/formatChecker';

interface Props extends React.HTMLAttributes<HTMLElement> {
  stories: Array<UserStoryShowcaseEntity>;
  title: string;
  subtitle?: string;
}

// 客戶故事區塊：服務說明頁（/abroad）與首頁「專業房產顧問團隊」共用。
// 外層出血（例如 `-mx-4`）依頁面容器而定，由使用端透過 className 傳入。
const ClientStorySection = forwardRef<HTMLElement | null, Props>(
  ({ stories, title, subtitle, className, ...props }, ref) => {
    const cards = useMemo<Array<SplitSwiperCard>>(() => {
      return stories.map(({ location, photoUrl, highlights, content, buyer }) => {
        return {
          img: photoUrl,
          city: location ?? '',
          content,
          customer: buyer,
          spotlights: highlights.map(({ label, value }) => ({ content: value, label })),
        };
      });
    }, [stories]);

    return (
      <section {...props} ref={ref} className={classNames('bg-black px-4 pt-4 pb-16', className)}>
        <p className={classNames('pt-4 text-white text-2xl text-center', isSet(subtitle) ? 'pb-2' : 'pb-4')}>
          {title}
        </p>
        <ConditionalFragment condition={isSet(subtitle)}>
          <p className={'pb-4 text-white text-center'}>{subtitle}</p>
        </ConditionalFragment>
        <SplitSwiperSection cards={cards} />
      </section>
    );
  }
);

export default ClientStorySection;
